var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "iiko-access-modal",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c("remove-access-modal", {
        ref: "removeAccessModal",
        on: { remove: _vm.onRemove },
      }),
      _c(
        "c-sidesheet",
        {
          attrs: { active: _vm.active, title: _vm.title },
          on: { close: _vm.close },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _vm.access
                    ? _c("c-button", {
                        staticClass: "iiko-access-modal__remove",
                        attrs: {
                          size: "small",
                          label: "Удалить",
                          icon: { icon: "trash", color: "secondary" },
                        },
                        on: { click: _vm.remove },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "iiko-access-form" }, [
            _c("div", { staticClass: "iiko-access-form__container" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col col-12" },
                  [
                    _c("c-input", {
                      staticClass: "iiko-access-form__field",
                      class: {
                        "iiko-access-form__field--invalid":
                          _vm.terminalNameError,
                      },
                      attrs: {
                        "floating-label": "Название терминала",
                        clearable: true,
                        "max-length": 255,
                        required: _vm.terminalNameError,
                        "required-message": _vm.terminalNameError,
                      },
                      model: {
                        value: _vm.form.terminalName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "terminalName", $$v)
                        },
                        expression: "form.terminalName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-6" },
                  [
                    _c("c-input", {
                      staticClass: "iiko-access-form__field",
                      class: {
                        "iiko-access-form__field--invalid": _vm.terminalIdError,
                      },
                      attrs: {
                        "floating-label": "ID терминала (IIKO)",
                        clearable: true,
                        required: _vm.terminalIdError,
                        "required-message": _vm.terminalIdError,
                        "max-length": 255,
                      },
                      model: {
                        value: _vm.form.terminalId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "terminalId", $$v)
                        },
                        expression: "form.terminalId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-6" },
                  [
                    _c("c-input", {
                      staticClass: "iiko-access-form__field",
                      class: {
                        "iiko-access-form__field--invalid": _vm.hostError,
                      },
                      attrs: {
                        "floating-label": "Хост",
                        clearable: true,
                        required: _vm.hostError,
                        "required-message": _vm.hostError,
                        "max-length": 255,
                      },
                      model: {
                        value: _vm.form.host,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "host", $$v)
                        },
                        expression: "form.host",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-6" },
                  [
                    _c("c-input", {
                      staticClass: "iiko-access-form__field",
                      class: {
                        "iiko-access-form__field--invalid": _vm.loginError,
                      },
                      attrs: {
                        "floating-label": "Логин",
                        clearable: true,
                        required: _vm.loginError,
                        "required-message": _vm.loginError,
                        "max-length": 255,
                      },
                      model: {
                        value: _vm.form.login,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "login", $$v)
                        },
                        expression: "form.login",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col col-12 col-md-6" },
                  [
                    _c("c-input", {
                      ref: "password",
                      staticClass: "iiko-access-form__field",
                      class: {
                        "iiko-access-form__field--invalid": _vm.passwordError,
                      },
                      attrs: {
                        "floating-label": "Пароль",
                        type: "password",
                        required: _vm.passwordError,
                        "required-message": _vm.passwordError,
                        "max-length": 255,
                      },
                      model: {
                        value: _vm.form.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "iiko-access-form__actions" },
                [
                  _c("c-button", {
                    staticClass: "iiko-access-form__reset",
                    attrs: { size: "large", label: "Отменить" },
                    on: { click: _vm.close },
                  }),
                  _c("c-button", {
                    staticClass: "iiko-access-form__save",
                    attrs: {
                      label: "Сохранить",
                      disabled: !_vm.hasData,
                      color: "primary",
                      size: "large",
                    },
                    on: { click: _vm.submit },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }